



































































































import { Component, Vue } from "vue-property-decorator";
import { authenticationStore } from "../api/authentication/authentication.module";
import { CampaignModel } from "../models/Campaign";
import md5 from "md5";
import initials from "initials";
import { campaignsStore } from "../store/campaigns.store";
import { CampaignUtils } from "../utils/campaign.utils";
import { appStore } from "../store/stores";
//#D9D9D9
@Component
export default class Profile extends Vue {
  md5 = md5;
  initials = initials;

  util = CampaignUtils;

  get user() {
    return authenticationStore.user;
  }

  get campaigns(): CampaignModel[] {
    return campaignsStore.campaigns;
  }

  get configuration() {
    return appStore.configuration;
  }

  mounted() {
    this.getCampaigns();
  }

  async getCampaigns() {
    try {
      this.showLoading();
      await campaignsStore.getCampaigns();
    } catch (error) {
      this.toastError("Error fetching campaigns");
    } finally {
      this.hideLoading();
    }
  }
}
